/**
 * Логика освещения: светильник по id и проверка «это светильник» для проводки.
 */
import type { CatalogItem } from "../../types";
import { lightingSection } from "./catalog";
import type { LightingCatalogItem } from "./types";

export const lightingItemById = (id: string): LightingCatalogItem | null =>
	lightingSection.items.find((item) => item.id === id) ?? null;

/** Светильник ли это — по членству в разделе освещения. Группы освещения идут по кабелям сквозь них. */
export const isLight = (item: CatalogItem | null): boolean =>
	item !== null && lightingItemById(item.id) !== null;
